<template>
  <div class="fade-in">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-6-desktop is-offset-3-desktop is-paddingless">
              <div class="card">
                <div class="card-content">
                  <h2 class="title">Reset Password</h2>
                  <form class="form-auth-small" @submit.prevent="onSubmit">
                    <div class="field">
                      <label class="label">Email</label>
                      <div class="control has-icons-left has-icons-right">
                        <input
                          class="input"
                          type="email"
                          v-model="user.email"
                          placeholder="Email"
                          autofocus
                        />
                        <span class="icon is-small is-left"
                          ><i class="fa fa-envelope"></i
                        ></span>
                      </div>
                    </div>

                    <div class="field">
                      <label class="label">Password</label>
                      <div class="control has-icons-left has-icons-right">
                        <input
                          class="input"
                          type="password"
                          v-model="user.password"
                          placeholder="Password"
                          required
                        />
                        <span class="icon is-small is-left"
                          ><i class="fa fa-lock"></i
                        ></span>
                      </div>
                    </div>

                    <div class="field">
                      <label class="label">Password Confirmation</label>
                      <div class="control has-icons-left has-icons-right">
                        <input
                          class="input"
                          type="password"
                          v-model="user.passwordConfirmation"
                          placeholder="Password"
                          required
                        />
                        <span class="icon is-small is-left"
                          ><i class="fa fa-lock"></i
                        ></span>
                      </div>
                    </div>

                    <div class="field is-grouped">
                      <div class="control">
                        <button
                          :class="[
                            'button',
                            'is-primary',
                            'is-large',
                            { 'is-loading': loading }
                          ]"
                        >
                          Reset
                        </button>
                      </div>
                      <div class="control">
                        <router-link
                          :to="{ name: 'login' }"
                          class="button is-link"
                          style="margin-top: 8px;"
                          >Login
                        </router-link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-toastr ref="toastr"></vue-toastr>
    </section>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import AuthService from "@/services/AuthService";

export default {
  name: "forgot-password-reset",

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      user: {
        email: "",
        password: "",
        passwordConfirmation: ""
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      AuthService.resetPassword(this.user, this.$route.query.token)
        .then(() => {
          this.$refs.toastr.s("Your password has been reset.");
          this.user.email = "";
          this.user.password = "";
          this.user.passwordConfirmation = "";
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$refs.toastr.e(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.forgot-password-reset {
  .navbar,
  .aside {
    display: none;
  }
  .column.col-content.is-9-desktop.is-10-widescreen.is-three-quarters-tablet.is-mobile {
    width: 100%;
    padding: 0;
  }
  section.section {
    padding: 0;
  }

  .card-content {
    padding: 2.14rem;
  }
}
</style>
